import ajax from '@/helpers/ajax'

const PersistAndToast = {
  props: {
    persist: {
      type: Boolean,
      required: false,
      default: false
    },

    // this is necessary if persist is true
    path: {
      type: String,
      required: false
    },
    field: {
      type: String,
      required: false
    }
  },

  emits: ['change'],

  data() {
    return {
      message: null
    }
  },

  methods: {
    save(payload) {
      const data = {}
      data[this.field] = payload.value.toString()

      ajax.put({
        url: this.path,
        params: data,
        successHandler: this.successCallback,
        errorHandler: this.errorCallback
      }).then(this.completedCallback)
    },

    errorCallback(error) {
      this.message = {
        message: error.message,
        status: 'error'
      }
      if (this.rubberBandOnError === true) {
        const { currentValue } = error.info
        if (currentValue !== undefined && this.initialValue !== currentValue) {
          // We do this to get a nice effect with the toggle animation toggling itself back to the previous state when there is an error.
          setTimeout(() => {
            this.$emit('change', currentValue)
          }, 500)
        }
      }
    },

    successCallback({message}) {
      if (message) {
        this.message = { message }
      }
    },

    completedCallback() {
      setTimeout(() => {
        this.message = null
      }, 5000)
    }
  }
}

export default PersistAndToast
